import { render, staticRenderFns } from "./HeaderDropdown.vue?vue&type=template&id=34ed78d0&"
import script from "./HeaderDropdown.vue?vue&type=script&lang=js&"
export * from "./HeaderDropdown.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDropdown.vue?vue&type=style&index=0&id=34ed78d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports